
const CHENG = (a: number, b: number) => {
  return Number((a * b).toFixed(3));
}
const CHU = (a: number, b: number) => {
  return Number((a / b).toFixed(3));
}

// 新版目录计算天数
// 整盒销售修改数量计算天数
export function getNewAutoChangePriceUseDays(changeName: any, selectData: any, doseUnit: any, doseFixJDJZ: any, doseFixWH: any, drugCount: any, normalFrequency: any, normalDose: any, flag?: any) {
  // �静注 �静注 雾化计算天数  
  if (doseFixJDJZ || doseFixWH) {
    // 标准型
    if (flag == '0') {
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位 （向下取整）
        //  (数量 × 最小包装数量 ÷（（单次剂量 / 容量）向上取整 × 频次）)
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.minPackNums)),CHENG(Math.ceil(CHU(normalDose,Number(selectData?.capacity))), normalFrequency)))
      } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位（向下取整）
        // 天数 = 数量 /（单次剂量向上取整 × 频次）
        return Math.floor(CHU(Number(drugCount), CHENG(Math.ceil(normalDose), normalFrequency)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
        //  天数 = 数量 × 最小包装数量 / ( (单次剂量 / 容量) 向上取整 × 频次 ) 
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.minPackNums)),CHENG(Math.ceil(CHU(normalDose,Number(selectData?.capacity))), normalFrequency)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
        // 天数 = 数量 × 最小包装数量 / ( (单次剂量 / 成分含量) 向上取整 × 频次 ) 
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.minPackNums)),CHENG(Math.ceil(CHU(normalDose,Number(selectData?.components))), normalFrequency)))
      }
    } else {
      //节约型
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位 （向下取整）
        // 天数 = (数量 × 最小包装数量) / (单次剂量 × 频次)
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.minPackNums)), CHENG(normalDose, normalFrequency)))
      } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位（向下取整）
        // 天数 = 数量 /（单次剂量 × 频次）
        return Math.floor(CHU(Number(drugCount), CHENG(normalDose, normalFrequency)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
        //  天数 = 数量 × 最小包装数量 × 容量  / (单次剂量 × 频次)
        return Math.floor(CHU(CHENG(CHENG(Number(drugCount), Number(selectData?.minPackNums)), Number(selectData?.capacity)), CHENG(normalDose, normalFrequency)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
        // 天数 = 数量 × 最小包装数量 × 成分含量 / (单次剂量 × 频次)
        return Math.floor(CHU(CHENG(CHENG(Number(drugCount), Number(selectData?.minPackNums)), Number(selectData?.components)), CHENG(normalDose, normalFrequency)))
      }
    }
  } else {
    if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位 （向下取整）
      // 天数 = (数量 × 最小包装数量) / (单次剂量 × 频次)
      return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.minPackNums)), CHENG(normalDose, normalFrequency)))
    } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位（向下取整）
      // 天数 = 数量 /（单次剂量 × 频次）
      return Math.floor(CHU(Number(drugCount), CHENG(normalDose, normalFrequency)))
    } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
      //  天数 = 数量 × 容量 × 最小包装数量 / (单次剂量 × 频次)
      return Math.floor(CHU(CHENG(CHENG(Number(drugCount), Number(selectData?.capacity)), Number(selectData?.minPackNums)), CHENG(normalDose, normalFrequency)))
    } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
      // 天数 = 数量 × 成分含量 × 最小包装数量 / (单次剂量 × 频次)
      return Math.floor(CHU(CHENG(CHENG(Number(drugCount), Number(selectData?.components)), Number(selectData?.minPackNums)), CHENG(normalDose, normalFrequency)))
    }
  }
}

// 拆零销售修改数量计算拆零的天数
export function getNewAutoChangePriceSplitUseDays(changeName: any, selectData: any, doseUnit: any, doseFixJDJZ: any, doseFixWH: any, drugCount: any, normalFrequency: any, normalDose: any, flag?: any) {
  // 静滴/静注 雾化计算天数
  if (doseFixJDJZ || doseFixWH) {
    // 标准型
    if (flag == '0') {
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向下取整）
        // 天数 = 数量 / (单次剂量向上取整 × 频次)
        return Math.floor(CHU(Number(drugCount), CHENG(Math.ceil(normalDose), normalFrequency)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
        // 天数 = (数量 ÷（向上取整 (单次剂量 ÷ 容量) × 频次）) 
        return Math.floor(CHU(Number(drugCount),Math.ceil(CHENG(CHU(normalDose,Number(selectData?.capacity)),normalFrequency))))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
        // 天数 = (数量 ÷（向上取整 (单次剂量 ÷ 成分含量) × 频次）) 
        return Math.floor(CHU(Number(drugCount),Math.ceil(CHENG(CHU(normalDose,Number(selectData?.components)),normalFrequency))))
      }
    } else {
      //节约型
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向下取整）
        // 天数 = 数量 / (单次剂量 × 频次)
        return Math.floor(CHU(Number(drugCount), CHENG(normalDose, normalFrequency)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
        // 天数 = 数量 × 容量 / (单次剂量 × 频次)
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.capacity)), CHENG(normalDose, normalFrequency)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
        // 天数 = 数量 × 成分含量 / (单次剂量 × 频次)
        return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.components)), CHENG(normalDose, normalFrequency)))
      }
    }
  } else {
    if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位 （向下取整）
      // 天数 = 数量 / (单次剂量 × 频次 )
      return Math.floor(CHU(Number(drugCount), CHENG(normalDose, normalFrequency)))
    } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向下取整）
      //  天数 = 数量 × 容量 ÷ (单次剂量 × 频次)
      return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.capacity)), CHENG(normalDose, normalFrequency)))
    } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向下取整）
      // 天数 = 数量 × 成分含量 ÷ (单次剂量 × 频次)
      return Math.floor(CHU(CHENG(Number(drugCount), Number(selectData?.components)), CHENG(normalDose, normalFrequency)))
    }
  }
}


// 新版目录计算数量
// 整盒销售修改数量计算数量
export function getNewAutoChangePriceDrugCount(changeName: any, selectData: any, doseUnit: any, doseFixJDJZ: any, doseFixWH: any, frequencyCalc: any, normalDose: any, useDays: any, flag?: any) {
  // 静滴/静注 雾化计算数量
  if (doseFixJDJZ || doseFixWH) {
    // 标准型
    if (flag == '0') {
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整）
        // 数量 = （（单次剂量b/容量e）向上取整× 频次a）*天数/最小包装数量i=A（向上取整）
        return Math.ceil(CHU(CHENG(Math.ceil(CHU(normalDose ,Number(selectData?.capacity))), Number(useDays)),Number(selectData?.minPackNums)))
      } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位（向上取整）
        // 数量 = （单次剂量向上取整 × 频次）*天数
        return CHENG(CHENG(Math.ceil(normalDose), frequencyCalc), Number(useDays))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
        //数量 = (（单次剂量/容量 向上取整 ) × 频次a*天数）向上取整 /最小包装数量
        return Math.ceil(CHU(Math.ceil(CHENG(CHENG(Math.ceil(CHU(normalDose ,Number(selectData?.capacity))), frequencyCalc),Number(useDays))),Number(selectData?.minPackNums)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
        // 数量 = （（（（单次剂量/成分含量）向上取整 × 频次a*天数）向上取整 /最小包装数量
        return Math.ceil(CHU(Math.ceil(CHENG(CHENG(Math.ceil(CHU(normalDose ,Number(selectData?.components))),frequencyCalc),Number(useDays))),Number(selectData?.minPackNums)))
      }
    } else {
      //节约型
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整）
        // 数量 = (单次剂量 × 频次）*天数/最小包装数量
        return Math.ceil(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.minPackNums)))
      } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位（向上取整）
        // 数量 = （单次剂量 × 频次）*天数
        return Math.ceil(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
        //数量 = （（单次剂量 × 频次）*天数/容量） /最小包装数量
        return Math.ceil(CHU(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.capacity)), Number(selectData?.minPackNums)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
        // 数量 = （（单次剂量 × 频次）*天数/成分含量） /最小包装数量 
        return Math.ceil(CHU(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.components)), Number(selectData?.minPackNums)))
      }
    }
  } else {
    if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整）
      // 数量 = （单次剂量 × 频次）* 天数/最小包装数量 
      return Math.ceil(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.minPackNums)))
    } else if (doseUnit == selectData?.accountUnit) { //剂量单位选择包装单位
      // 数量 = （单次剂量 × 频次）* 天数 
      return Math.ceil(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)))
    } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
      //数量 = （单次剂量 × 频次）* 天数/容量/最小包装数量 
      return Math.ceil(CHU(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.capacity)), Number(selectData?.minPackNums)))
    } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
      // 数量 = （（单次剂量 × 频次）* 天数/成分含量）/最小包装数量 
      return Math.ceil(CHU(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.components)), Number(selectData?.minPackNums)))
    }
  }
}

// 拆零销售修改数量计算拆零的数量
export function getNewAutoChangePriceSplitDrugCount(changeName: any, selectData: any, doseUnit: any, doseFixJDJZ: any, doseFixWH: any, frequencyCalc: any, normalDose: any, useDays: any, flag?: any) {
  // 静滴/静注 雾化计算拆零的数量
  if (doseFixJDJZ || doseFixWH) {
    // 标准型
    if (flag == '0') {
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整）
        // 数量 = （单次剂量向上取整 × 频次）*天数
        return Math.ceil(CHENG(CHENG(Math.ceil(normalDose), frequencyCalc), Number(useDays)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
        //数量 =  (单次剂量/容量)向上取整 × 频次*天数
        return Math.ceil(CHENG(CHENG(Math.ceil(CHU(normalDose,Number(selectData?.capacity))),frequencyCalc),Number(useDays)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
        // 数量 =   (单次剂量/成分含量)向上取整 × 频次*天数
        return Math.ceil(CHENG(CHENG(Math.ceil(CHU(normalDose,Number(selectData?.components))),frequencyCalc),Number(useDays)))
      }
    } else {
      //节约型
      if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整）
        // 数量 =（单次剂量 × 频次）*天数
        return Math.ceil(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)))
      } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
        //数量 = （单次剂量 × 频次）*天数/容量
        return Math.ceil(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.capacity)))
      } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
        // 数量 = （单次剂量 × 频次）*天数/成分含量
        return Math.ceil(CHU(CHENG(CHENG(normalDose, frequencyCalc), Number(useDays)), Number(selectData?.components)))
      }
    }
  } else {
    if (doseUnit == selectData?.minPackUnit) { //剂量单位选择最小包装单位（向上取整） 
      // 数量 =（单次剂量 × 频次）* 天数
      return Math.ceil(CHENG(CHENG(normalDose, (frequencyCalc)), Number(useDays)))
    } else if (doseUnit == selectData?.capacityUnit) { //剂量单位选择容量单位（向上取整）
      // 数量 =（单次剂量 × 频次）* 天数/容量
      return Math.ceil(CHU(CHENG(CHENG(normalDose, (frequencyCalc)), Number(useDays)), Number(selectData?.capacity)))
    } else if (doseUnit == selectData?.componentsUnit) { //剂量单位选择成分含量单位（向上取整）
      // 数量 = （单次剂量 × 频次）* 天数/成分含量
      return Math.ceil(CHU(CHENG(CHENG(normalDose, (frequencyCalc)), Number(useDays)), Number(selectData?.components)))
    }
  }
}

const CHENGS = (a: number, b: number) => {
  return Number((a * b).toFixed(1));
}
const CHUS = (a: number, b: number) => {
  return Number((a / b).toFixed(1));
}

// 老版目录计算天数
// 修改数量计算天数
export function getOldAutoChangePriceUseDays(changeName: any, doseFix: any, drugCount: any, calc: any, normalDose: any, doseConvert: any) {
  // 静滴/静注计算天数
  if (doseFix) {
    // 天数 = 数量 / (频次*（剂量/转换比 先取整）) 再整体取整
    return Math.floor(CHUS(Number(drugCount), CHENGS((calc || 0), Math.ceil(CHUS(normalDose, doseConvert)))));
  } else {
    // 天数 = 数量 / (频次*剂量/转换比) 一次取整
    return Math.floor(CHUS(CHENGS(Number(drugCount), doseConvert), CHENGS((calc || 0), normalDose)))
  }
}

// 修改数量计算拆零的天数
export function getOldAutoChangePriceSplitUseDays(changeName: any, doseFix: any, drugCount: any, calc: any, normalDose: any) {
  // 静滴/静注计算拆零的天数
  if (doseFix) {
    // 天数 = 数量 / (频次*（剂量/转换比 先取整）) 再整体取整
    return Math.floor(CHUS(Number(drugCount), CHENGS((calc || 0), Math.ceil(normalDose))));
  } else {
    // 天数 = 数量 / (频次*剂量/转换比) 一次取整
    return Math.floor(CHUS(Number(drugCount), CHENGS((calc || 0), normalDose)))
  }
}

// 老版目录计算数量
// 修改频次 剂量 天数计算数量
export function getOldAutoChangePriceDrugCount(changeName: any, doseFix: any, useDays: any, pc: any, normalDose: any, doseConvert: any, frequencyCalc?: any) {
  if (changeName == 'normalDose') {
    if (doseFix) {
      // 数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), Number(useDays)), (Math.ceil(CHUS(Number(normalDose), doseConvert)))));
    } else {
      // 数量 = 频次*天数*剂量/转换比 一次取整
      return Math.ceil(CHUS(CHENGS(CHENGS((frequencyCalc), Number(normalDose)), useDays), doseConvert))
    }
  } else if (changeName == 'useDays') {
    if (doseFix) {
      // 数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), Number(useDays)), (Math.ceil(CHUS(normalDose, doseConvert)))));
    } else {
      // 数量 = 频次*天数*剂量/转换比 一次取整
      return Math.ceil(CHUS(CHENGS(CHENGS((frequencyCalc), normalDose), Number(useDays)), doseConvert))
    }
  } else {
    // 静滴/静注计算数量
    if (doseFix) {
      // 数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
      return Math.ceil(CHENGS(CHENGS(pc!, Number(useDays)), (Math.ceil(CHUS(normalDose, doseConvert)))));
    } else {
      // 数量 = 频次*天数*剂量/转换比 一次取整
      return Math.ceil(CHUS(CHENGS(CHENGS(pc!, normalDose), useDays), doseConvert))
    }
  }
}

// 修改频次 剂量 天数计算拆零的数量
export function getOldAutoChangePriceSplitDrugCount(changeName: any, doseFix: any, useDays: any, pc: any, normalDose: any, frequencyCalc?: any) {
  if (changeName == 'normalDose') {
    if (doseFix) {
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), Math.ceil(Number(normalDose))), Number(useDays)));
    } else {
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), Number(normalDose)), useDays))
    }
  } else if (changeName == 'useDays') {
    if (doseFix) {
      // 数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), Math.ceil(normalDose)), Number(useDays)));
    } else {
      // 数量 = 频次*天数*剂量/转换比 一次取整
      return Math.ceil(CHENGS(CHENGS((frequencyCalc), normalDose), Number(useDays)))
    }
  } else {
    // 静滴/静注计算拆零的数量
    if (doseFix) {
      // 数量 = 频次*天数*（剂量/转换比 先取整）再整体取整
      return Math.ceil(CHENGS(CHENGS(pc!, Math.ceil(normalDose)), Number(useDays)));
    } else {
      // 数量 = 频次*天数*剂量/转换比 一次取整
      return Math.ceil(CHENGS(CHENGS(pc!, normalDose), useDays))
    }
  }
}